import React from 'react'
import RoomSchedule from 'frontend/schedule/room-schedule'
import PlayersCountButtons from 'frontend/schedule/players-count-buttons'
import PlayersCountInput from 'frontend/schedule/players-count-input'
import MinPriceIndicator from 'frontend/schedule/min-price-indicator'
import RoomWeekSelect from 'frontend/schedule/room-week-select'
import Legend from 'frontend/schedule/legend'
import CommonIcons from 'frontend/components/common-icons'

export default class TuringTestSchedule extends RoomSchedule {
  renderFilters () {
    return (
      <div className="filters">
        <div className="select_players_count">
          <h4 className="title" aria-level="2">
            <span className="fix_title">Select number of players</span>
          </h4>
          <PlayersCountButtons
            playersWithMinPrices={this.state.schedule.minPriceByPlayersCount}
            selected={this.state.selectedPlayersCount}
            onSelect={this.handlePlayersCountSelect.bind(this)}
          />
          <div className="players_count_input_with_price_indicator">
            <PlayersCountInput
              minPlayers={this.state.schedule.minPlayers}
              maxPlayers={this.state.schedule.maxPlayers}
              value={this.state.selectedPlayersCount}
              onChange={this.handlePlayersCountSelect.bind(this)}
            />
            <MinPriceIndicator
              playersCount={this.state.selectedPlayersCount}
              playersWithMinPrices={this.state.schedule.minPriceByPlayersCount}
            />
          </div>
        </div>
        <div className="select_date">
          <h4 className="title" aria-level="2">
            <span className="fix_title">Select date of your game</span>
          </h4>
          <RoomWeekSelect
            selected={this.state.selectedDate}
            onChange={this.handleDateSelect.bind(this)}
          />
        </div>
      </div>
    )
  }

  renderHelpers () {
    return (
      <div className="helpers">
        <div className="eye_legend helper">
          <CommonIcons item="common-eye-r" className="icon" />
          Click on booked game <span className="color_text">(eye icon)</span>
          <br /> to see more options
        </div>
        <Legend types={this.state.schedule.minPriceByType} />
      </div>
    )
  }
}
